import React from "react";
import type { KanjiBonus } from "../../types/landing";
import { Sakura } from "./Decor";
interface BonusCoverProps {
  bonus: KanjiBonus;
  className?: string;
}
const tones: Record<KanjiBonus["tone"], {
  bg: string;
  text: string;
  sub: string;
  line: string;
  seal: string;
}> = {
  pizarra: {
    bg: "bg-pizarra-deep",
    text: "text-marfil",
    sub: "text-crema",
    line: "bg-marfil/30",
    seal: "bg-terracota-deep text-papel"
  },
  terracota: {
    bg: "bg-terracota-deep",
    text: "text-papel",
    sub: "text-sakura-light",
    line: "bg-papel/30",
    seal: "bg-pizarra-deep text-marfil"
  },
  salvia: {
    bg: "bg-salvia-deep",
    text: "text-papel",
    sub: "text-salvia-light",
    line: "bg-papel/30",
    seal: "bg-terracota-deep text-papel"
  },
  dorado: {
    bg: "bg-dorado-deep",
    text: "text-papel",
    sub: "text-crema",
    line: "bg-papel/30",
    seal: "bg-pizarra-deep text-marfil"
  },
  sakura: {
    bg: "bg-sakura",
    text: "text-pizarra-deep",
    sub: "text-pizarra",
    line: "bg-pizarra/25",
    seal: "bg-terracota-deep text-papel"
  }
};

/** Portada tipográfica de un bono de kanji, en la paleta de la marca */
export function BonusCover({
  bonus,
  className = ""
}: BonusCoverProps) {
  const t = tones[bonus.tone];
  return <div role="img" aria-label={`Portada del bono ${bonus.number}: ${bonus.title}`} className={`relative flex aspect-[3/4] flex-col overflow-hidden ${t.bg} ${t.text} ${className}`} data-id="element-296" data-mp="1gkdst4c2hu4b">
      <div className="seigaiha pointer-events-none absolute inset-x-0 bottom-0 h-1/4 opacity-70 invert" aria-hidden="true" data-id="element-297" data-mp="28bjuvqbcm1w8" />
      <div className="relative flex items-center justify-between px-4 pt-4" data-id="element-298" data-mp="249py3t49xi1c">
        <span className={`text-[11px] font-semibold ${t.sub}`} data-id="element-299" data-mp="1ziztwj7l3l88">Bono {bonus.number} · Kanji</span>
        <Sakura className={`h-3.5 w-3.5 ${t.sub}`} data-id="element-300" data-mp="1uketaiof6zj9" />
      </div>
      <div className="relative flex flex-1 flex-col items-center justify-center" data-id="element-301" data-mp="1ujwp8zvinh0s">
        <span className="font-kanji text-[5.5rem] leading-none md:text-[6rem]" aria-hidden="true" data-id="element-302" data-mp="2s0c4zh2jkw9r">
          {bonus.kanji}
        </span>
        <span className={`mt-2 text-xs italic ${t.sub}`} data-id="element-303" data-mp="2n6zmzpsdbnpz">{bonus.meaning}</span>
      </div>
      <div className="relative px-4 pb-4" data-id="element-304" data-mp="3675omtb7k17p">
        <span className={`block h-px w-8 ${t.line}`} aria-hidden="true" data-id="element-305" data-mp="3b4fega2ieew2" />
        <p className="mt-2 font-serif text-base font-medium leading-tight" data-id="element-306" data-mp="2xcr5gfnk46jb">{bonus.title}</p>
      </div>
      <span className={`absolute right-3 top-[38%] flex h-6 w-6 items-center justify-center rounded-sm font-kanji text-xs ${t.seal}`} aria-hidden="true" data-id="element-307" data-mp="31e48khz9lvmj">
        印
      </span>
    </div>;
}